import React from "react";
import { withFormik } from "formik";
import _ from "lodash";
import { FormikInputMoney, InputNumber, InputPercent, InputText, InputTypeAhead, PrimaryButton, SecondaryButton } from "@loanbossinc/component-library";
import { Grid } from "@material-ui/core";

import { PaddedWrapper, Row } from "../styles";

const TYPE_OPTIONS = [
  { name: "Dollars", id: "dollars" },
  { name: "$MM", id: "mm" },
  { name: "Percent", id: "percent" },
  { name: "Basis Points", id: "basis-points" },
  { name: "Ratio", id: "ratio" }
];

const HardCodedField = props => {
  const { setFieldValue, setFieldSelections, values, handleSubmit, isEditingLineItem, setDrawerSelections } = props;

  const { name = "", type = null, formattedValue = null } = values;

  const onCancel = () => {
    setFieldSelections({ currentSelectedFieldType: null, isAdding: false, isEditing: false, selectedField: null });
    if (isEditingLineItem) {
      setDrawerSelections({ isEditingLineItem: true, currentSectionName: "line-item-management" });
    }
  };

  const onTypeSelect = value => {
    if (value) {
      setFieldValue("type", value);
      setFieldValue("value", null);
      setFieldValue("formattedValue", null);
    } else {
      setFieldValue("type", null);
    }
  };

  const onValueChange = event => {
    const {
      target: { value }
    } = event;

    setFieldValue("formattedValue", value);

    switch (type) {
      case "mm":
        setFieldValue("value", parseFloat(value) * 1000000);
        break;
      case "basis-points":
        setFieldValue("value", parseInt(value, 10) / 10000);
        break;
      case "percent":
        setFieldValue("value", parseFloat(value) / 100);
        break;
      default:
        setFieldValue("value", parseFloat(value));
        break;
    }
  };

  const getValueInputByType = () => {
    switch (type) {
      case "dollars":
        return (
          <FormikInputMoney
            variant="filled"
            id="field-value"
            name="field-value"
            label="Value"
            fullWidth
            decimals={3}
            onChange={onValueChange}
            value={formattedValue || ""}
            disabled={!type}
          />
        );
      case "mm":
        return (
          <FormikInputMoney
            variant="filled"
            id="field-value"
            name="field-value"
            label="Value"
            fullWidth
            decimals={3}
            onChange={onValueChange}
            value={formattedValue || ""}
            disabled={!type}
          />
        );
      case "percent":
        return (
          <InputPercent
            variant="filled"
            id="field-value"
            name="field-value"
            label="Value"
            fullWidth
            decimals={3}
            onChange={onValueChange}
            value={formattedValue}
            disabled={!type}
          />
        );
      case "basis-points":
        return (
          <InputNumber
            variant="filled"
            id="field-value"
            name="field-value"
            label="Value"
            fullWidth
            decimals={0}
            onChange={onValueChange}
            value={formattedValue}
            disabled={!type}
          />
        );
      default:
        return (
          <InputNumber
            variant="filled"
            id="field-value"
            name="field-value"
            label="Value"
            fullWidth
            decimals={3}
            onChange={onValueChange}
            value={formattedValue}
            disabled={!type}
          />
        );
    }
  };

  const onNameChange = event => {
    const {
      target: { value }
    } = event;

    setFieldValue("name", value);
  };

  return (
    <>
      <PaddedWrapper padding="1em">
        <InputText variant="filled" label="Field Name" name="field-name" fullWidth onChange={onNameChange} value={name} />
      </PaddedWrapper>
      <Row borderBottom="none" justifyContent="space-between">
        <Grid container justify="space-between" alignItems="center" direction="row">
          <Grid item xs={6}>
            <PaddedWrapper>
              <InputTypeAhead
                variant="filled"
                id="field-value-type"
                name="field-value-type"
                label="Value Type"
                options={TYPE_OPTIONS}
                displayWith={option => option && option.name}
                setValueWith={option => option && option.id}
                onChange={onTypeSelect}
                value={type}
              />
            </PaddedWrapper>
          </Grid>
          <Grid item xs={6}>
            <PaddedWrapper padding="0 1em 0 0">{getValueInputByType()}</PaddedWrapper>
          </Grid>
        </Grid>
      </Row>
      <Row borderBottom="none" justifyContent="flex-end">
        <PaddedWrapper>
          <Grid container>
            <Grid item>
              <SecondaryButton size="sm" label="Cancel" onClick={onCancel} />
            </Grid>
            <Grid item>
              <PaddedWrapper padding="0 1em 0 1em">
                <PrimaryButton size="sm" label="Save" onClick={handleSubmit} disabled={!formattedValue || !name || !type} />
              </PaddedWrapper>
            </Grid>
          </Grid>
        </PaddedWrapper>
      </Row>
    </>
  );
};

export default withFormik({
  mapPropsToValues: ({ selectedField }) => ({ ...selectedField, rowsSelected: selectedField?.rowsSelected ?? [] }),
  handleSubmit(values, { props, setSubmitting }) {
    const {
      dealId,
      isAdding,
      postFieldConfig,
      putFieldConfig,
      setFieldSelections,
      changeDrawerStateIfInNewListItemMode,
      isEditingLineItem,
      setNoiCalculationsDashboardSelections,
      setDrawerSelections,
      setNewLineItemsSelectionsToDefault
    } = props;

    const payload = { ...values, isHardCoded: true, level: "all", dealId, calculations: [] };

    if (!payload.propertyId) {
      payload.propertyId = -1;
    }

    if (isAdding) {
      postFieldConfig({ data: payload });
    } else {
      putFieldConfig({ data: _.omit(payload, ["updatedAt", "createdAt"]) });
    }

    setSubmitting(false);
    changeDrawerStateIfInNewListItemMode();
    setFieldSelections({ currentSelectedFieldType: null, selectedField: null, isAdding: false, isEditing: false });
    if (isEditingLineItem) {
      setNoiCalculationsDashboardSelections({
        initialDrawerSectionName: null,
        isLenderReportingDrawerOpen: false,
        addLineItemType: null,
        lineItemToEdit: null
      });
      setDrawerSelections({ isEditingLineItem: false, currentSectionName: null });
      setNewLineItemsSelectionsToDefault();
    }
  }
})(HardCodedField);
